import {
  IEvent,
  TealiumEventNames,
  TealiumEventCategory,
  playerStateManager,
  PlayerStatus,
  StreamType,
} from '@4tn/core-audio-player-shared';
import { trackLink } from '../trackLink';
import { TealiumEvent } from '../../tealium-event';

export const streamStopTealiumEventHandler = (event: IEvent) => {
  const { playerVersion } = playerStateManager.getState();

  const mediaMetadata = event.media.getStreamSource();

  if (event?.media?.contentType === StreamType.STATION) {
    const tealiumEvent = new TealiumEvent({
      eventName: TealiumEventNames.PLAYER_STOP,
      eventCategory: TealiumEventCategory.PLAYER,
      player: {
        playerState: PlayerStatus.STOP,
        playerVersion,
      },
      mediaMetadata,
    });
    trackLink(tealiumEvent.getEventData());
  } else if (event.media?.contentType === StreamType.PODCAST) {
    const tealiumEvent = new TealiumEvent({
      eventName: TealiumEventNames.PLAYER_PAUSE,
      eventCategory: TealiumEventCategory.PLAYER,
      media: {
        mediaOffset: event.time,
      },
      player: {
        playerState: PlayerStatus.PAUSE,
        playerVersion,
      },
      mediaMetadata,
    });
    trackLink(tealiumEvent.getEventData());
  }
};
